import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import logo from "../../../images/PPKM_Head.png";
import { AppBar, Button, Typography } from "@mui/material";
import { CgProfile } from "react-icons/cg";
import { MdNotificationsActive } from "react-icons/md";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ClearIcon from "@mui/icons-material/Clear";
import "./header.css";

const Header = () => {
  // State to control visibility of the smaller header
  const [showSmallHeader, setShowSmallHeader] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation(); // Get current location
  const { eventId } = useParams(); // Get the event ID from URL

  // useEffect(() => {
  //   if (
  //     location.pathname === "/profile" ||
  //     location.pathname === "/notification" ||
  //     location.pathname === "/edit_profile" ||
  //     location.pathname === "/change_password" ||
  //     location.pathname === "/membership_renewal" ||
  //     location.pathname === "/secondary_account" ||
  //     location.pathname === "/my_event" ||
  //     location.pathname === "/discover_event" ||
  //     location.pathname === "/gallery" ||
  //     location.pathname === "/document" ||
  //     location.pathname === "/gallery_details" ||
  //     location.pathname === "/event_details/:eventId" ||
  //     location.pathname === "/view_event" ||
  //     location.pathname === "/event_payment"
  //   ) {
  //     setShowSmallHeader(true);
  //   } else {
  //     setShowSmallHeader(false);
  //   }
  // }, [location]);
  useEffect(() => {
    const smallHeaderPaths = [
      "/profile",
      "/notification",
      "/edit_profile",
      "/change_password",
      "/membership_renewal",
      "/secondary_account",
      "/my_event",
      "/discover_event",
      "/gallery",
      "/document",
      "/view_event",
      "/event_payment",
    ];

    // Include paths that match "/event_details/{eventId}"
    const isEventDetails = location.pathname.startsWith("/event_details");

    if (smallHeaderPaths.includes(location.pathname) || isEventDetails) {
      setShowSmallHeader(true);
    } else {
      setShowSmallHeader(false);
    }
  }, [location]);

  // Function to determine the text based on the current path
  // const getPageTitle = () => {
  //   const isEventDetails = location.pathname.startsWith("/event_details/");

  //   switch (true) {
  //     case "/profile":
  //       return "PROFILE";
  //     case "/notification":
  //       return "NOTIFICATION";
  //     case "/edit_profile":
  //       return "EDIT PROFILE";
  //     case "/change_password":
  //       return "CHANGE PASSWORD";
  //     case "/membership_renewal":
  //       return "MEMBERSHIP";
  //     case "/secondary_account":
  //       return "SECONDARY ACCOUNT";
  //     case "/my_event":
  //       return "MY EVENT";
  //     case "/discover_event":
  //       return "DISCOVER EVENTS";
  //     case "/gallery":
  //       return "GALLERY";
  //     case "/document":
  //       return "DOCUMENTS";
  //     case "/gallery_details":
  //       return "GALLERY DETAILS";
  //     case location.pathname.startsWith("/event_details/"):
  //       return "EVENT DETAILS";
  //     case "/view_event":
  //       return "QR CODE";
  //     case "/event_payment":
  //       return "FILL IN DETAILS";
  //     // Add more cases as needed
  //     default:
  //       return "";
  //   }
  // };
  const pageTitles = {
    "/profile": "PROFILE",
    "/notification": "NOTIFICATION",
    "/edit_profile": "EDIT PROFILE",
    "/change_password": "CHANGE PASSWORD",
    "/membership_renewal": "MEMBERSHIP",
    "/secondary_account": "SECONDARY ACCOUNT",
    "/my_event": "MY EVENT",
    "/discover_event": "DISCOVER EVENTS",
    "/gallery": "GALLERY",
    "/document": "DOCUMENTS",
    "/gallery_details": "GALLERY DETAILS",
    "/view_event": "QR CODE",
    "/event_payment": "FILL IN DETAILS",
    // Add more paths as needed
  };

  const getPageTitle = () => {
    // Check if the path has an exact match in the pageTitles map
    const exactTitle = pageTitles[location.pathname];
    if (exactTitle) {
      return exactTitle;
    }

    // For dynamic routes, add specific checks
    if (location.pathname.startsWith("/event_details/")) {
      return "EVENT DETAILS";
    }

    // Default title if no match is found
    return "";
  };

  return (
    <React.Fragment>
      {/* Conditionally render either the main header or the smaller header */}
      {!showSmallHeader ? (
        <AppBar className="d-flex home-header">
          <div>
            <div className="row d-flex align-items-center">
              {/* Logo Wrapper */}
              <div className="col-sm-8 part1">
                <img
                  src={logo}
                  className="dashboard-logo"
                  alt="logo"
                  onClick={() => navigate("/dashboard")}
                />
                <div className="text-group">
                  <span className="g1">PPK MALAYSIA</span>
                  <span className="g2">
                    Malaysia Shopping Malls Association
                  </span>
                </div>
              </div>
              <div className="d-flex col-sm-4 welcome">
                <span>Welcome! User 1</span>
                <div className="d-flex align-items-center justify-content-end part3">
                  <Button
                    className="rounded-circle"
                    onClick={() => navigate("/profile")}
                  >
                    <CgProfile />
                  </Button>
                  <Button
                    className="rounded-circle"
                    onClick={() => navigate("/notification")}
                  >
                    <MdNotificationsActive />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </AppBar>
      ) : (
        <AppBar className="d-flex small-header">
          <div>
            <div className="row d-flex align-items-center">
              {/* Logo Wrapper */}
              <div className="col-sm-8 part1">
                <ArrowBackIosIcon
                  className="logo"
                  onClick={() => navigate(-1)}
                />
                <div className="text-group2">
                  <span className="g3">{getPageTitle()}</span>
                </div>
                <ClearIcon
                  className="logo"
                  onClick={() => navigate("/dashboard")}
                />
              </div>
            </div>
          </div>
        </AppBar>
      )}
    </React.Fragment>
  );
};

export default Header;
